import { styled } from '@mui/material/styles';
import { Box, CssBaseline, Toolbar, Typography } from '@mui/material';
import MuiAppBar from '@mui/material/AppBar';
import React, { Suspense, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import { useDispatch, useSelector } from 'react-redux';
import { setAmphurDataMap, setAmphurData, setProvinceDataMap, setProvinceData, setTambonDataMap, setTambonData, setRegionData, setRegionDataMap } from '../../reducer/areaDataSlice';
import dotenv from 'react-dotenv';
import { useNavigate } from 'react-router-dom';
import { getIAAM } from '../../reducer/iaamSlice';
import { setD506Updatetime } from '../../reducer/updateTimeSlice';
import { setDengueSetting } from '../../reducer/dengueSettingSlice';

const drawerWidth = 320;

function LinearProgressWithLabel(props) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ minWidth: 100, mr: 1 }}>
                <Typography variant="body2" color="text.secondary">{props.title}</Typography>
            </Box>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

LinearProgressWithLabel.propTypes = {
    value: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired
};

function LoadingScreen(props) {
    const navigate = useNavigate();
    const decoder = new TextDecoder("utf-8");
    const dispatch = useDispatch();
    const iaam = useSelector(getIAAM);
    const [regionProgress, setRegionProcess] = useState(0);
    const [provinceProgress, setProvinceProgress] = useState(0);
    const [amphurProgress, setAmphurProgress] = useState(0);
    const [tambonProgress, setTambonProgress] = useState(0);

    useEffect(() => {
        const getTambonData = async (page, result) => {
            let response = await fetch(`${dotenv.MASTER_API_URL}/area/tambon?bbox=true&geojson=true`);

            if (!response?.body) return;
            // const contentLength = response.headers.get('Content-Length');
            const contentLength = '45207680';
            const totalLength = typeof contentLength === 'string' && parseInt(contentLength);

            
            // console.log(totalLength);

            const reader = response.body.getReader();
            let valueResponse = '';

            let receivedLength = 0;

            while (true) {
                const { done, value } = await reader.read();
                if (done) {
                    break;
                }

                let stringValue = decoder.decode(value);
                valueResponse = valueResponse + stringValue;

                receivedLength = receivedLength + value.length;
                if (typeof totalLength === 'number') {
                    const step = parseFloat((receivedLength / totalLength).toFixed(2)) * 100;
                    setTambonProgress(step);
                }
            }
            let jsonData = JSON.parse(valueResponse);
            let tambonMap = {};
            for (let index = 0; index < jsonData.length; index++) {
                const element = jsonData[index];
                tambonMap[element.tambon_code] = element;
            }
            dispatch(setTambonData(jsonData));
            dispatch(setTambonDataMap(tambonMap));
            let urlLoading = localStorage.getItem("loading");
            if (urlLoading === null) {
                navigate('/monitor/map');
            } else {
                navigate(urlLoading);
            }

        }
        const getAmphurData = async (page, result) => {
            let response = await fetch(`${dotenv.MASTER_API_URL}/area/amphur?bbox=true&geojson=true`);
            if (!response?.body) return;
            // const contentLength = response.headers.get('Content-Length');
            const contentLength = '5429358';
            const totalLength = typeof contentLength === 'string' && parseInt(contentLength);

            // console.log(totalLength);

            const reader = response.body.getReader();
            let valueResponse = '';

            let receivedLength = 0;

            while (true) {
                const { done, value } = await reader.read();
                if (done) {
                    break;
                }

                let stringValue = decoder.decode(value);
                valueResponse = valueResponse + stringValue;

                receivedLength = receivedLength + value.length;
                if (typeof totalLength === 'number') {
                    const step = parseFloat((receivedLength / totalLength).toFixed(2)) * 100;
                    setAmphurProgress(step);
                }
            }

            // console.log()

            const jsonData = JSON.parse(valueResponse);
            let ampMap = {};
            for (let index = 0; index < jsonData.length; index++) {
                const element = jsonData[index];
                ampMap[element.amp_code] = element;
            }
            // result = [...result, ...jsonData];
            // if (page === 2) {
            // dispatch(setAmphurData(result));
            dispatch(setAmphurData(jsonData));
            dispatch(setAmphurDataMap(ampMap));
            getTambonData(1, []);
            // } else {
            //     getAmphurData(page + 1, result);
            // }
        }
        const getProvinceData = async () => {
            const response = await fetch(`${dotenv.MASTER_API_URL}/area/province?bbox=true&geojson=true`);

            if (!response?.body) return;
            // const contentLength = response.headers.get('Content-Length');
            const contentLength = '2253156';
            const totalLength = typeof contentLength === 'string' && parseInt(contentLength);

            // console.log(totalLength);

            const reader = response.body.getReader();
            let valueResponse = '';

            let receivedLength = 0;

            while (true) {
                const { done, value } = await reader.read();
                if (done) {
                    break;
                }

                let stringValue = decoder.decode(value);
                valueResponse = valueResponse + stringValue;

                receivedLength = receivedLength + value.length;
                if (typeof totalLength === 'number') {
                    const step = parseFloat((receivedLength / totalLength).toFixed(2)) * 100;
                    // console.log(step);
                    setProvinceProgress(step);
                }
            }

            const jsonData = JSON.parse(valueResponse);
            const provMap = {};
            for (let index = 0; index < jsonData.length; index++) {
                const element = jsonData[index];
                provMap[element.prov_code] = element;
            }
            dispatch(setProvinceData(jsonData));
            dispatch(setProvinceDataMap(provMap));
            getAmphurData(1, []);
        }
        const getRegionData = async () => {
            const provinceCodeMap = {
                "dpc-01": ["50", "51", "52", "54", "55", "56", "57", "58"],
                "dpc-02": ["53", "63", "64", "65", "67"],
                "dpc-03": ["18", "60", "61", "62", "66"],
                "dpc-04": ["12", "13", "14", "15", "16", "17", "19", "26"],
                "dpc-05": ["70", "71", "72", "73", "74", "75", "76", "77"],
                "dpc-06": ["11", "20", "21", "22", "23", "24", "25", "27"],
                "dpc-07": ["40", "44", "45", "46"],
                "dpc-08": ["38", "39", "41", "42", "43", "47", "48"],
                "dpc-09": ["30", "31", "32", "36"],
                "dpc-10": ["33", "34", "35", "37", "49"],
                "dpc-11": ["80", "81", "82", "83", "84", "85", "86"],
                "dpc-12": ["90", "91", "92", "93", "94", "95", "96"],
                "dpc-13": ["10"]
            }
            const response = await fetch(`${dotenv.MASTER_API_URL}/dpc/get_dpc?bbox=true&geojson=true`);

            if (!response?.body) return;
            // const contentLength = response.headers.get('Content-Length');
            const contentLength = '1149387';
            const totalLength = typeof contentLength === 'string' && parseInt(contentLength);

            // console.log(totalLength);

            const reader = response.body.getReader();
            let valueResponse = '';

            let receivedLength = 0;

            while (true) {
                const { done, value } = await reader.read();
                if (done) {
                    break;
                }

                let stringValue = decoder.decode(value);
                valueResponse = valueResponse + stringValue;

                receivedLength = receivedLength + value.length;
                if (typeof totalLength === 'number') {
                    const step = parseFloat((receivedLength / totalLength).toFixed(2)) * 100;
                    // console.log(step);
                    setRegionProcess(step);
                }
            }

            let jsonData = JSON.parse(valueResponse);
            for (let index = 0; index < jsonData.length; index++) {
                const health_region_code = jsonData[index].health_region_code;
                jsonData[index]["prov_list"] = provinceCodeMap[health_region_code];
            }
            let regionMap = {};
            for (let index = 0; index < jsonData.length; index++) {
                const element = jsonData[index];
                regionMap[element.health_region_code] = element;
            }
            let dpcList = jsonData.sort((a, b) => {
                return a.health_region_code.localeCompare(b.health_region_code);
            })
            dispatch(setRegionData(dpcList));
            dispatch(setRegionDataMap(regionMap));
            getProvinceData();
            // getAmphurData(1, []);
        }
        const getD506UpdateTime = async () => {
            try {
                let access_token = await iaam.getAccessToken();
                // console.log(access_token);
                // console.log(access_token)
                let options = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `bearer ${access_token}`
                    }
                }

                let res = await iaam.fetch(`${dotenv.SECURE_API_URL}/d506/patient-updated-date`, options);
                const resData = await res.json()
                dispatch(setD506Updatetime(resData.updated_date));
                // console.log(res);

                getRegionData();
            } catch (error) {
                console.log(error);
                navigate("/")
            }
        }
        const setting = localStorage.getItem('trb-watch-setting');
        if (setting !== null) {
            const dengueSetting = JSON.parse(setting)['1'];
            if (dengueSetting !== undefined) {
                dispatch(setDengueSetting(dengueSetting));
            }
        }
        // console.log(setting === null);
        // if (setting) {

        // }
        // const dengueSetting = JSON.parse(setting)['1'];
        // console.log(dengueSetting)
        // dispatch(setDengueSetting(JSON.parse(setting)))
        // console.log(JSON.parse(setting));
        getD506UpdateTime();
        // const provinceData = localStorage.getItem("provinceData");
        // if (provinceData === null) {
        // getRegionData();
        // getProvinceData();
        // } else {

        // }
    }, [dispatch])

    const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
        ({ theme, open }) => ({
            flexGrow: 1,
            padding: theme.spacing(3),
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            // marginLeft: `-${drawerWidth}px`,
            ...(open && {
                transition: theme.transitions.create('margin', {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
                marginLeft: 0,
            }),
        }),
    );

    const AppBar = styled(MuiAppBar, {
        shouldForwardProp: (prop) => prop !== 'open',
    })(({ theme, open }) => ({
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        ...(open && {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: `${drawerWidth}px`,
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        }),
    }));

    return (
        <Box sx={{ display: 'flex', overflow: 'hidden', height: '100vh' }}>
            <CssBaseline />
            <AppBar position="fixed">
                <Toolbar
                    className='bg-white bg-gradient-to-bl from-blue-50 via-gray-100 to-slate-50'
                >
                    <Box display='flex' flexGrow={1}>
                        <img className="h-6 w-6 my-1.5" alt="candice" src="/images/Watch-Logo-Color.png" />
                        <Typography
                            as="a"
                            href="#"
                            className="mr-4 ml-2 cursor-pointer py-1.5 text-black font-bold font-primary tracking-wide text-xl"
                        >
                            ทันระบาด<span className="text-blue-600">ติดตาม</span>
                        </Typography>
                    </Box>
                </Toolbar>
            </AppBar>
            <Main className='p-0 mt-[60px] overflow-auto'>
                <Suspense>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                    }}>
                        <Typography style={{
                            fontSize: '30px',
                            height: '50px',
                            lineHeight: '50px',
                        }}>กำลังโหลดข้อมูลพื้นที่</Typography>
                        <div style={{
                            width: '40%',
                            alignContent: 'center',
                            textAlign: 'center',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <LinearProgressWithLabel title='เขตสุขภาพ' value={regionProgress} />
                        </div>
                        <div style={{
                            width: '40%',
                            alignContent: 'center',
                            textAlign: 'center',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <LinearProgressWithLabel title='จังหวัด' value={provinceProgress} />
                        </div>
                        <div style={{
                            width: '40%',
                            alignContent: 'center',
                            textAlign: 'center',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <LinearProgressWithLabel title='อำเภอ' value={amphurProgress} />
                        </div>
                        <div style={{
                            width: '40%',
                            alignContent: 'center',
                            textAlign: 'center',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <LinearProgressWithLabel title='ตำบล' value={tambonProgress} />
                        </div>
                    </div>
                </Suspense>
            </Main>
        </Box>
    )
}

export default LoadingScreen
